<template>
  <v-col>
    <v-row v-if="showSummaries && !reportId">
      <v-col>
        <summary-card-bar />
      </v-col>
    </v-row>

    <v-row>
      <v-col class="organization pt-3">
        <data-table
          v-if="!reportId || reportId === 'dashboard'"
          ref="table"
          :actions="isUserInternalAdmin ? actions : []"
        />

        <org-profile v-else />

        <org-modal />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import mixin from '../components/mixin'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'Organization',
  components: {
    OrgModal: () => import('../components/OrgModal'),
    OrgProfile: () => import('../components/Org'),
    SummaryCardBar: () => import('@/tools/components/summary/SummaryCardBar'),
  },
  mixins: [mixin],
  data() {
    return {
      actions: [
        {
          event: 'internal/showFormOrganizationUpdate',
          name: 'Edit',
        },
        {
          event: 'internal/showFormOrganizationDelete',
          name: 'Delete',
        },
        {
          event: 'internal/goToOrganization',
          name: 'View Profile',
        },
      ],
    }
  },
  computed: {
    ...mapAuthGetters(['isUserInternalAdmin']),
    ...mapToolsGetters([
      'showSummaries',
    ]),
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),
    reportId() {
      return this.selectedSearch && this.selectedSearch.reportId
    },
  },
}
</script>
